import React from 'react';
import ReactTooltip from 'react-tooltip';

const styles = {
  booked: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    height: '100%',
    borderTop: '10px solid #FF8000'
  },
  patientName:{
    fontSize: 14,
    fontWeight:'bold'
  },
  symptom:{
    fontSize: 12
  }
}

const Booked = ({slot, doctor, index, appointment, setSlotWithDoctor}) => (
  <td
    className="click__effect"
    rowSpan="1"
    key={index}
    onClick={() => {setSlotWithDoctor(doctor, slot)}}
    >
      <ReactTooltip/>

    <div data-tip="Click to delete schedule" style={styles.booked}>
      <div style={styles.patientName}> {appointment.mission.patient.name} </div>
      <div style={styles.symptom}> {appointment.mission.initial_conditions} </div>
    </div>

  </td>
);

export default Booked;


// WEBPACK FOOTER //
// ./src/screens/schedules/slots/booked.js